import { BsFillShieldLockFill, BsTelephoneFill } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import { IoReloadOutline } from "react-icons/io5";
import React, { useState, useEffect } from 'react';
import OtpInput from "otp-input-react";
import { useRecoilState } from 'recoil';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth } from "./firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import { user_data, user_login_state, user_role, w_labels, langs, chosen_lang, redir, surveys, _online, _enablesurvey, _orglogo } from '../RecoilState';
import Text from '../components/Text'
import axios from 'axios';
import { Spin, message, Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';


// SSL BD MIDDLEWARE OTP


const BDMWOTP = () => {
  const [otp, setOtp] = useState("");
  const [ph, setPh] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(null);
  const [isonline, setIsonline] = useRecoilState(_online);
  const [labels, setLabels] = useRecoilState(w_labels);
  const [justphonenumber, setJustPhonenumber] = useState("");
  const [timeLeft, setTimeLeft] = useState(30);
  const [isRunning, setIsRunning] = useState(false);
  const [firebaseToken, setFirebasetoken] = useState("");
  const [userfound, setUserfound] = useState(true)
  const [pageRefresh, setPagerefresh] = useState(false)
  const [redirect, setRedirect] = useRecoilState(redir);
  const [userdata, setUserdata] = useRecoilState(user_data);
  const [loginstate, setLoginstate] = useRecoilState(user_login_state);
  const [userrole, setUserrole] = useRecoilState(user_role);
  const [buttonclicked, setButtonclicked] = useState(false);
  const [firebaseerror, setFirebaseerror] = useState("")
  const [usernotfound, setUsernotfound] = useState(false)
  const [correctotp, setCorrectotp] = useState(0)
  const [enablesurvey, setEnablesurvey] = useRecoilState(_enablesurvey)
  const [orglogo, setOrglogo] = useRecoilState(_orglogo)


  console.log("SSL Server OTP")


  // const startTimer = () => {
  //   setIsRunning(true);
  // };

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isRunning, timeLeft]);



  useEffect(() => {
    if (timeLeft === 0) {
      setIsRunning(false);
      setTimeLeft(30);
    }
  }, [timeLeft])

  function onRetry() {
    setOtp("")
    console.log("onRetry");
    const justnumber = ph.toString().slice(-10);
    formatSSL(justnumber)
  }

  function checkRegistration() {
    console.log("checkRegistration")
    setButtonclicked(true);
    delete axios.defaults.headers.common["Authorization"];

    const justnumber = ph.toString().slice(-10);
    // console.log(justnumber)
    setJustPhonenumber(justnumber);

    const data = {
      username: justnumber
    };

    axios.post('auth/username', data)
      .then(response => {
        const valid = response.data.data.isRegistered;
        // setUserfound(valid)
        // toast.success("OTP sent successfully!");
        // console.log(response.data)
        if (valid === true) {
          // onSignup()
          formatSSL(justnumber)
        }
        else {
          setButtonclicked(false);
          setUsernotfound(true);
          // toast.error("User not found");
        }

        // else {
        //   console.log("user not found")
        // }
        // console.log(response);
      })
      .catch(error => {
        // console.log(error);
        // setUserfound(false);
        setButtonclicked(false);
        toast.error("Server Error");
      });
  }

  function formatSSL(justnumber) {

    var msgbody = {
      number: justnumber,
      type: orglogo.name,
    };

    sendotpssl(msgbody)
  }

  function sendotpssl(msgbody) {
    // console.log(justnumber);

    // console.log(msgbody);

    // SSL wireless API, disable/comment for developement

    axios.post('ssl-otp/generate', msgbody)
      .then(response => {
        console.log(response.data);
        // setLoading(false);
        // setShowOTP(true);
        // setIsRunning(true);
        // setButtonclicked(false);
      })
      .catch(error => {
        // console.log(error);
        // setLoading(false);
        // setIsRunning(false);
        // setTimeLeft(30);
        // setPagerefresh(true);
        // setButtonclicked(false);
      });

    setLoading(false);
    setShowOTP(true);
    setIsRunning(true);
    setButtonclicked(false);
  }

  function verifysslotp() {
    // if (otp == correctotp) {
    //   console.log('Match!');
    //   // Handle successful OTP verification (e.g., proceed to next step)
    //   middlewareFirebaseauth(otp)
    // } else {
    //   console.log('Codes do not match.');
    //   // Handle incorrect OTP (e.g., display an error message)
    // }

    var msgbody = {
      number: justphonenumber,
      OTP: otp,
    };

    // console.log(msgbody);

    axios.post('ssl-otp/verify', msgbody)
      .then(response => {
        console.log(response.data);
        if (response.data.status === "success") {
          var token = response.data.data;
          middlewareFirebaseauth(token)
        }
        else {
          // console.log('Codes do not match.');
          setOtp("")
        }
      })
      .catch(error => {
        // console.log(error);
        // console.log('Codes do not match.');
        setOtp("")
      });
  }

  function middlewareFirebaseauth(token) {
    localStorage.setItem('respondent_mpu_token', token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
    getProfiledata();
  }

  function getProfiledata() {
    // console.log('getProfiledata')
    axios.get('respondent/profile')
      .then(response => {
        // console.log(response)
        setUserdata(response.data.data);
        setUserrole(response.data.data.type);
        setEnablesurvey(response.data.data.enabled_for_survey)
        // dob(response.data.data.date_of_birth);
        setRedirect("welcome")
        // console.log("respondent profile");
        // console.log(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  function Usernotregistered() {

    function retrybutton() {
      // console.log("clicked")
      setPh("")
      setUsernotfound(false)
    }

    return (
      <>
        <div className='mt-[100px] mb-[20px]'>
          <Text style={"sub-heading text-bold text-center"} value={labels[47]} />
          <Text style={"sub-heading text-center"} value={labels[59]} />
        </div>
        <div className="flex justify-center mt-10">
          <Button type="secondary" shape="round" size="large" onClick={() => retrybutton()}>
            <div className="flex justify-center gap-x-4 items-center">
              {/* <Text style={"text"} value={labels[58]} /> */}
              <div className="mx-[5px]"> </div>
              <IoReloadOutline />
              <div className="mx-[5px]"> </div>
            </div>
          </Button>
        </div>
      </>
    )
  }

  return (
    <div className="header-accomodate">
      <div className="spacer">
        <div className="mb-5">
          <Text style={"large-gradient-heading text-center"} value={labels[8]} />
        </div>

        {usernotfound ?
          <Usernotregistered />
          :
          // firebase OTP validation UI
          <>
            <section className="flex items-center justify-center mb-[30px]">
              <div>
                <Toaster toastOptions={{ duration: 1000 }} />
                <div id="recaptcha-container"></div>
                {
                  user ?
                    (
                      // login success
                      <h2 className="text-center font-medium text-l mt-5">
                        Login Success. Loading
                        <Spin />
                      </h2>
                    )
                    :
                    (
                      <div className="w-full flex flex-col gap-4 rounded-lg p-4">
                        {
                          showOTP ?
                            (
                              /* input otp */
                              <>
                                <h2 className="font-bold text-xl text-left">+{ph}</h2>
                                <div className="mb-2">
                                  <Text style={"text"} value={labels[45]} />
                                </div>
                                <OtpInput
                                  value={otp}
                                  onChange={setOtp}
                                  OTPLength={6}
                                  otpType="number"
                                  disabled={false}
                                  autoFocus
                                  className="opt-container"
                                ></OtpInput>
                                <button
                                  onClick={verifysslotp}
                                  className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                >
                                  {loading && (
                                    <CgSpinner size={20} className="mt-1 animate-spin" />
                                  )}
                                  <span>
                                    <Text style={"text"} value={labels[4]} />
                                  </span>
                                </button>

                                <div className="mb-2 mt-[50px]">
                                  <Text style={"text"} value={labels[5]} />
                                </div>


                                {/* resend */}
                                {isRunning ? <h2>Resend in {timeLeft} seconds</h2>
                                  :
                                  (
                                    <>
                                      <button
                                        onClick={onRetry}
                                        className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                      >
                                        {loading && (
                                          <CgSpinner size={20} className="mt-1 animate-spin" />
                                        )}
                                        <span>
                                          <Text style={"text"} value={labels[6]} />
                                        </span>
                                      </button>
                                    </>
                                  )
                                }

                              </>
                            )
                            :
                            (

                              <>
                                {/* verify phone number */}
                                <>
                                  <label
                                    htmlFor=""
                                    className="font-bold text-xl mt-[30px]"
                                  >
                                    <div className='mb-[20px]'>
                                      <Text style={"text sub-heading"} value={labels[42]} />
                                    </div>
                                  </label>
                                  <PhoneInput country={"bd"} onlyCountries={['bd']} value={ph} onChange={setPh} />
                                  {
                                    buttonclicked ?
                                      (
                                        <div className="mt-5 mx-auto">
                                          <Spin />
                                        </div>
                                      )
                                      :
                                      (
                                        <button
                                          onClick={checkRegistration}
                                          className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                        >
                                          {loading && (
                                            <CgSpinner size={20} className="mt-1 animate-spin" />
                                          )}
                                          <span>
                                            <Text style={"text"} value={labels[43]} />
                                          </span>
                                        </button>
                                      )
                                  }
                                </>
                              </>
                            )
                        }
                      </div>
                    )
                }
              </div>
            </section>
            <div className="mt-[30px]">
              {/* page refresh message */}
              {
                pageRefresh ?
                  (
                    // <>
                    //   {/* <h2 className="text-center">Please refresh this page</h2> */}
                    //   <Text style={"text-heading text-center"} value={labels[46]} />
                    // </>
                    null
                  )
                  :
                  null
              }
            </div>
          </>
        }

        {/* <div className="mt-6">
          <p>------------</p>
          <p>for testing puropses only</p>
          <p>{firebaseerror}</p>
        </div> */}
      </div>
    </div>
  );
};

export default BDMWOTP;
